module.exports = __webpack_public_path__ + "img/anm3.4f89d681.png";